import React, { useEffect, useState, Fragment } from 'react';
import { Button, CheckList, List, NavBar, Popup } from 'antd-mobile';
import { get } from 'lodash';
import { CloseOutline, CheckCircleFill, CheckCircleOutline } from 'antd-mobile-icons';
import styled from 'styled-components';
import InputComponent from './Input';

const ChecklistWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
`;

const ContentWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow: auto;
	width: 100%;
	background: #f0f2f5;
`;

const Nav = styled(NavBar)`
	background: #fff;
	display: flex;
	border-bottom: solid 1px var(--adm-color-border);
`;

const Save = styled(Button)`
	font-size: 17px;
`;


function ChecklistPopup(props) {
	const {
		visible,
		onClose,
		onSave,
		disabled,
		checklistData,
		checklist,
		saving
	} = props;
	const [checked, setChecked] = useState(get(checklistData[checklist.id], 'checked') || []);
	const [comment, setComment] = useState(get(checklistData[checklist.id], 'comment') || '');

	function handleChecklistChange(values) {
		setChecked(values);
	}

	function onSaveClick() {
		const existingData = checklistData[checklist.id] || {};
		const newData = {
			...existingData,
			checked,
			comment
		};

		onSave({
			work_finalization_data: {
				...checklistData,
				[checklist.id]: newData
			}
		});
	}

	useEffect(() => {
		setChecked(get(checklistData[checklist.id], 'checked') || []);
		setComment(get(checklistData[checklist.id], 'comment') || '');
	}, [checklist, visible]);

	return (
		<Fragment>
			<Popup
				position='right'
				visible={visible}
				destroyOnClose={true}
				bodyStyle={{ width: '100%' }}
				onClose={onClose}
			>
				<ChecklistWrapper>
					<Nav
						backArrow={<CloseOutline />}
						onBack={onClose}
						back={''}
						right={<Save fill='none' loading={saving} onClick={onSaveClick}>Save</Save>}
					>
						{checklist.title}
					</Nav>
					<ContentWrapper>
						<List header="Checklist" />
						<CheckList
							multiple
							extra={active =>
								(active ?
									<CheckCircleFill fontSize={24} color="var(--adm-color-success)" /> :
									<CheckCircleOutline fontSize={24} color="var(--adm-color-light)" />
								)
							}
							onChange={handleChecklistChange}
							value={checked}
						>
							{(get(checklist, 'checklist') || []).map((c, i) => <CheckList.Item disabled={disabled} key={i} value={c}>{c}</CheckList.Item>)}
						</CheckList>
						<InputComponent
							title="Comment"
							type="text"
							placeholder="Add comment about this checklist"
							onSave={async ({ comment: commentValue }) => setComment(commentValue)}
							dataKey="comment"
							initialValue={comment}
							disabled={disabled}
						/>
					</ContentWrapper>
				</ChecklistWrapper>
			</Popup>
		</Fragment>
	);
}

export default ChecklistPopup;
